module.exports = __webpack_public_path__ + "img/28_10.8a5be25c.png";